import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/topship.png'
import _imports_1 from '../../../assets/images/Terminal.png'
import _imports_2 from '../../../assets/images/RelianceHealth.png'
import _imports_3 from '../../../assets/images/Pharmrun.png'


const _hoisted_1 = { className: "bg-[#FFB13C] pt-[6rem] pb-[6rem]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: "mx-auto max-w-7xl sm:px-6 lg:px-8" }, [
  /*#__PURE__*/_createElementVNode("div", { className: "text-[1.25rem] px-6 leading-[1.2] sm:px-0 sm:text-[16px] text-[#2C2C2C] font-[800] text-center m-auto pb-[2rem]" }, " Clients that has worked with us over the years "),
  /*#__PURE__*/_createElementVNode("div", { className: "flex mt-5 items-center flex-wrap justify-center sm:justify-between" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      className: "sm:mr-9 mb-7",
      alt: "partners"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      className: "sm:mr-9 mb-7",
      alt: "partners"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      className: "sm:mr-9 mb-7",
      alt: "partners"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      className: "sm:mr-9 mb-7",
      alt: "partners"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}